import wallHangingsData from "./wallHangingsData";

export default [
    {
        id: 'ombre',
        title: 'Ombre',
        image: '/assets/images/fabrics/ombre.jpg',
        variations: [
            {
                title: 'Ombre',
                image: '/assets/images/fabrics/ombre.jpg',
                description: <div>
To dye a piece of fabric like this, I lay a large piece of wet cloth on my dye table outside. I mix 7 to 10 colors of liquid dye, and pour them on the cloth, blending each color into the next. I hang the piece carefully to dry on the line (quite a trick with 2 or 3 yards of cloth, only one person, and wind to contend with!)
                </div>
            },
            {
                title: 'Salt variation',
                image: '/assets/images/fabrics/salt.jpg',
                description: <div>
                    Above is a variation on the ombre above. After smoothing the dyes on as for an ombre piece, I sprinkled rock salt on the piece and let it dry flat on my dyeing table. I'm not really sure why the salt makes it do what it does, but it's a beautiful effect. It could be that the particles of salt draw moisture from the air, and the dye takes to the fabric differently because of the varying rates of drying
                </div>
            }
        ]
    },
    {
        id: 'sueded',
        title: 'Sueded',
        image: '/assets/images/fabrics/Suede.jpg',
        variations: [
            {
                title: 'the "sueded look"',
                image: '/assets/images/fabrics/Suede.jpg',
                description: <div>
                    Essentially, this is just an unevenly dyed piece of cloth. If you were trying to accieve a piece of uniform coloring, you would consider it a failure.  To me, though, it's infinitely more interesting than a solid.  Basically, I'm stuffing too much cloth into a dye bath that's too small, and not stirring the whole mess.  One of the things I love is how the dyes separate; if you look closely here, you can perhaps see several shades of blues and purples, even though the whole cloth was put into just one dye bath.
                </div>
            },
            {
                image: '/assets/images/fabrics/TurquoiseRustBlotch.jpg',
                description: <div>
Here's a relative of the technique above.  This one was scrunched up into a plastic zip-lock bag, had two colors of dye mixture poured on it, and allowed to sit for a good long spell.  yum!
                </div>
            }
        ]
    },
    {
        id: 'textured',
        title: 'Textured',
        image: '/assets/images/fabrics/BrushOmbre.jpg',
        variations: [
            {
                image: '/assets/images/fabrics/BrushOmbre.jpg',
                description: <div>
                    On the right is a fairly long length of fabric, dyed entirely with a large round sponge (it was sold as something with which to apply paint to walls). I prepared several colors of thickened dye, and dipped the sponge in each one, applying color until all the white had disappeared. As you can see, purples predominate at one end, dark green at the other.
                    <br /><br />
                    On the left is a fabric that was made in two phases; the second was an ombre, but before that I put some texture on the cloth in two ways. The brown is thickened dye, applied directly onto the cloth with a stiff broom which had been discarded (I tell ya, you look at the world --and especially trash-- in a different way once you get going on this dyeing stuff!)
                </div>
            },
            {
                title: 'Sponges',
                image: '/assets/images/fabrics/SpongeGradation.jpg',
                description: <div>
                    Above is a fairly long length of fabric, dyed entirely with a large round sponge (it was sold as something with which to apply paint to walls). I prepared several colors of thickened dye, and dipped the sponge in each one, applying color until all the white had disappeared. As you can see, purples predominate at one end, dark green at the other.
                </div>
            },
        ],
    },
    {
        id: 'mop-up',
        title: 'Mop-up',
        image: '/assets/images/fabrics/MopIce.jpg',
        variations: [
            {
                image: '/assets/images/fabrics/MopIce.jpg',
                description: <div>
                   Here's about the most basic technique of all; in fact, it's a laugh to call it a technique...
<br /><br />
I do much of my dye-work on a table, and in the course of nearly any kind of dyeing, there'll be some dye left on the table after I remove the fabric.  Ya gotta clean up the table, right?  Why wipe up perfectly good dye with a sponge, when you can mop it up with another piece of cloth?On this page I give you several examples of mop-up, some (like the one on the left) done with a dry cloth, some (like the one below) done on a damp cloth. 
                </div>
            },
            {
                image: '/assets/images/fabrics/MopMoss.jpg',
            },
            {
                image: '/assets/images/fabrics/MopWarmDet.jpg',
            },
            {
                image: '/assets/images/fabrics/MopBlack.jpg',
            },
            {
                image: '/assets/images/fabrics/MopComplexDet.jpg',
                description: <div>
                    Very often, of course, I'll mop up my table with a cloth I've previously used for mopping up the table at some other point.  The fabrics above and to the left are good examples of this; it looks like the first layer (or the first several!) were mopped when the cloth was damp, and then the final layer (black above, and teal blue on the left) was thickened, smeared on the table, and then mopped when the fabric was dry.  (Yes, I do sometimes do this intentionally, too!)
                </div>
            },
        ]
    },
    {
        id: 'twisting',
        title: 'Twisting',
        image: '/assets/images/fabrics/twist.jpg',
        variations: [
            {
                image: '/assets/images/fabrics/twist.jpg',
                description: <div>
                    dye, then twist
<br /><br />
This method of dyeing found me once when I wanted to dye a bedsheet, much too large to fit on my 4' x 8' table. I splashed several splashes of dye on the (activated, and still wet) sheet, and then to spread the dye around, I rolled the whole thing into a long sausage-shape and twisted really hard ! I've found that this technique works very nicely when I leave some white on the cloth; the colors fill in the white spaces, and the resulting cloth often has an airiness that I find appealing.
                </div>
            },
            {
                image: '/assets/images/fabrics/MonetMulti.jpg',
                description: <div>
                    The cloth above is a detail of another piece of cloth twisted after the dye is applied. You get a good idea of how the colors mix and don't mix as they repeat themselves accross the fabric.
                </div>
            },
            {
                image: '/assets/images/fabrics/4ydGreenSmall.jpg',
                description: <div>
                    On the left is a piece of fabric whose intensity took me totally by surprise.  I had been dyeing other things, and had a bunch of dyes left, but they were all blues and yellows.  I just threw them on a 4 yard piece of cotton sateen I had lying around, rolled the whole thing up (from bottom to top) and twisted.  I honestly didn't think it would be particularly interesting, but it turned out to be one of my favorite pieces of cloth!  Something about the particular shades of color and the way they mingle, as well as the size and proportions of the piece, seemed very special to me.
                    <br /><br />
                    I kept the cloth intact for several years until I found someone (with a 2 story foyer) who wanted a piece large enough for me to use it. Waterside was the result, and you can see in the gallery.
                </div>
            }
        ]
    },
    {
        id: 'rolling',
        title: 'Rolling',
        image: '/assets/images/fabrics/roll-then-dye.jpg',
        variations: [
            {
                image: '/assets/images/fabrics/roll-then-dye.jpg',
                description: <div>
                    roll-then-dye
                    <br /><br />
                    For a cloth like the one above, I first activate the fabric and wring it out. Starting from the side that is the top in this picture, I roll the fabric, ending up with a package about 3" x 42". I then flatten the roll, and paint liquid dyes on, letting them soak all the way through to the very inside of the roll. I turn the flattened roll over, and soak in some more dye. Then I let the roll rest for at least 24 hours (still rolled up) before washing it. Unrolling it to wash it is like opening a present!
                </div>
            },
            {
                image: '/assets/images/fabrics/SnailWilliamMorris.jpg',
                description: <div>
                Above is another variation. For this one, I accordion-folded the fabric, then rolled the whole thing up like a snail shell. I then put it in a confined space (in this case, a plastic jar), and poured dyes -some thickened, some not- into the jar. A little bit of agitation, and then patience...  And look what happened!
                </div>
            },
            {
                image: '/assets/images/fabrics/SnailMulti.jpg',
                description: <div>
                    Above is another piece dyed in the same manner as the one above. On the day I made rthis one, however, there was a wider variety of colors to dump into the jar!
                </div>
            }
        ]
    },
    {
        id: 'squeezed',
        title: 'Squeezed',
        image: '/assets/images/fabrics/Squiggle.jpg',
        variations: [
            {
                image: '/assets/images/fabrics/Squiggle.jpg',
                description: <div>
                    The title pretty much says it all:
                    <br /><br />
                    I squeezed thickened orange dye out of a small plastic bottle onto cloth that had been laid on my dye-table.  After it was dry, I did an ombre of various yellows on top of the pattern that was already there.  Different effects happen if the cloth is wet or dry when the squiggling takes place, and you can do things in the reverse order too, making the doodles on top of previously-dyed cloth.  Lots of fun!
                </div>
            }
        ]
    },
    {
        id: 'arashi-shibori',
        title: 'Arashi Shibori',
        image: '/assets/images/fabrics/ShGreenPurpleYellow.jpg',
        variations: [
            {
                image: '/assets/images/fabrics/ShOneColor.jpg',
                description: <div>
                    The piece of cotton above was pleated and wrapped around a pole (actually a 4" diameter PVC pipe) at an angle. I then wrapped string around the cloth, squished the cloth and the string together, and painted with unthickened dye.
                </div>
            },
            {
                image: '/assets/images/fabrics/ShGreenPurpleYellow.jpg',
                description: <div>
                    Above is a close-up of another piece of arashi shibori. As you can see, many colors can be applied to the same cloth. Depending on several factors (which goes on first, whether each dye is or is not thickened, and probably the phase of the moon!), different colors will appear in different places, and will mix in others. Again, a delight to take the fabric off the pole and see what's happened!
                </div>
            },
            {
                image: '/assets/images/fabrics/ShGreenStrip.jpg'
            }
        ]
    },
    {
        id: 'stitch-resist',
        title: 'Stitch Resist',
        image: '/assets/images/fabrics/FilligreeDet.jpg',
        variations: [
            {
                image: '/assets/images/fabrics/rasp.jpg',
                description: <div>
Above is a simple machine-stitch resist. After forming accordion folds, I machine sewed a very simple zigzag down the length of the folded fabric. I don't mark the zigzag on the fabric; I do it free-hand so it will be somewhat irregular. 
                </div>
            },
            {
                image: '/assets/images/process/other/StitchResistBrown.jpg',
                description: <div>
                    In the picture above, I show another stich resist as I'm in the process of taking out the stiching. You can see the packet that I've sewn, and just a little bit of the cloth that's inside. The entire cloth is nearly 2 yards!
                </div>
            },
            {
                image: '/assets/images/fabrics/FilligreeDet.jpg',
                description: <div>
                    Above is a slightly more elaborate design, but again done by accordion-folding the fabric (which was mint-green to begin with), drawing a curvy pattern on the bundle, and machine stitching through the whole thing.  The lines of stitching stay the original color, although a bit of dye comes through each needle hole, making a very lovely and interesting effect
                    <br /><br />
                    A note about the outside of the packet: after many attempts at this sort of cloth, I finally discovered a way to avoid having some folds of the accordion-package take up much less dye than other parts. The secret is Tyvec (the stuff the postal service makes Priority Mail envelopes of); if I put strips of Tyveck on the outside of my accordion, the dye only penetrates through the stitches, and at the sides of the packet. The dots of the stitching become much more prominent, and the whole cloth is pretty much evenly dyed.
                </div>
            },
            {
                image: '/assets/images/fabrics/StitchBlueSimple.jpg',
                description: <div>
                    And above is a simpler stitch resist, though very pleasing.
                </div>
            }
        ]
    },
    {
        id: 'clamp-shibori',
        title: 'Clamp Shibori',
        image: '/assets/images/fabrics/TwelveStar.jpg',
        details: <div>
For the clamping sort of shibori, one takes a piece of cloth, folds it in various ways, puts something stiff on each end of the bundle, and compresses it by clamping these pieces together. Part of the fabric is then readily accessible to the dye, whereas other parts can't be reached.
        </div>,
        variations: [
            {
                image: '/assets/images/fabrics/tortoise.jpg',
                title: 'Tortoiseshell shibori',
                description: <div>
                    I started with a piece of cloth I'd dyed a fairly uniform light grey/purple. Then I folded it, first with an accordion pleat, and then to make equilateral triangles. When it was all folded, I dipped each side of the resulting triangle shape in dye.. .first liquid orange and gold, and then thickened dye of a deep burgundy color.
                </div>
            },
            {
                image: '/assets/images/fabrics/HexagonFlowers.jpg',
                title: 'Hexagon flower',
                description: <div>
                    The piece above is folded exactly as the one above is.  I started with a piece I'd dyed various soft shades of yellow, and after folding, I secured the bundle with rubber bands.  I ended up with this wonderful flower-like arrangement!
                </div>
            },
            {
                image: '/assets/images/fabrics/Clamp.jpg',
                description: <div>
                 Above is a very simple "clamp resist" (actually secured with rubber bands; you can see them in white on the bottom row of the cloth, which was the outside of the bundle when I dyed it).  The folding was very straightforward: first accordion-folding the fabric into a long strip, the accordion-folding into half-square triangles.   
                </div>
            },
            {
                image: '/assets/images/fabrics/TwelveStar.jpg',
                title: 'Twelve star',
                description: <div>
                    I can't really describe how to do this fold; I made it up but it's a bit complicated.  I was delighted with the results: twelve-pointed stars, elegant rhomboid shapes, and equilateral triangles!
                </div>
            }
        ]
    },
    {
        id: 'chopsticks',
        title: 'Chopsticks',
        image: '/assets/images/fabrics/Chopstick.jpg',
        details: <div>
            Again, my first step was to accordion-fold the fabric. Using pairs of plastic chopsticks and rubber bands to hold the pairs together, I made a pattern on the folded fabric, and then painted dye on, letting it soak through all the layers.
        </div>,
        variations: [
            {
                image: '/assets/images/fabrics/Chopstick.jpg',
            }
        ]
    },
    {
        id: 'monoprint',
        title: 'Monoprint',
        image: '/assets/images/fabrics/MonoLuminous.jpg',
        details: <div></div>,
        variations: [
            {
                image: '/assets/images/fabrics/MonoLuminous.jpg',
                description: <div>
                    Above is a very simple monoprint. I smeared thickened dye on my table (which is covered with vinyl, so the dye beads up a bit) and then carefully laid a piece of white fabric on top, right side down (in this case, it was a sateen, so it actually did matter). Later I poured unthickened blue dye over the piece and smoothed it on. I love the gesture of the monoprint --the curve my hand made in spreading out the thickened dye.
                </div>
            },
            {
                image: '/assets/images/fabrics/MonoMixed.jpg',
                description: <div>
                    You can clearly see the effect of having more than one color on the table at the same time.
                </div>
            },
            {
                image: '/assets/images/fabrics/Mono3Color.jpg',
                description: <div>
                    Above I've built up three separate layers of monoprint, and then applied unthickened blue dye over the as-yet-unwashed cloth. The purple layer was smeared on the table in the same manner as the first piece shown on this page, but for the brown and green layers, I did something extra after smearing the dye on the table. I raked through the dye with a notched trowel (a little plastic job you can get at the hardware store for less than a buck) to make a pattern on the table-top. These trowels come with differently-sized notches on each side, and you can see that I used the wide notches for the brown, and the more closely-spaced notches for the green.,
                </div>
            },
            {
                image: '/assets/images/fabrics/MonoOrangeSharp.jpg',
                description: <div>
                    Above is another example, with many layers built on top of each other, making a wonderfully complex fabric.
                </div>
            }
        ]
    },
    {
        id: 'presist',
        title: 'Presist',
        image: '/assets/images/fabrics/PresistPurple.jpg',
        details: <div></div>,
        variations: [
            {
                image: '/assets/images/fabrics/PresistPurple.jpg',
                description: <div>
                    I produced this piece of cloth from a soft purple fabric.  The resist I used is called Presist, and is a thick liquid which I apply with a small squeeze bottle.  Once the Presist has dried, I apply thickened dye (in this case, various shades of blue and purple) with a paint roller.  The "ghost" images of the resist pattern are a result of folding up the cloth while it's still damp; I like the added textural feeling this gives the cloth.
                </div>
            }
        ]
    },
    {
        id: 'masking-tape',
        title: 'Masking Tape',
        image: '/assets/images/fabrics/MaskingSquares.jpg',
        details: <div></div>,
        variations: [
            {
                image: '/assets/images/fabrics/MaskingSquares.jpg',
                description: <div>
               One of my favorite resists, masking tape is fun and easy! On the left is a piece of ombre cloth to which I applied hand-torn squares of 3" wide masking tape, and then rolled over the masked cloth with thickened black dye.  The original colors come through in the darkened part of the cloth too, making a very rich fabric.     
                </div>
            },
            {
                image: '/assets/images/babyquilts/bqPicnic.jpg',
                description: <div>
                Above is a piece of fabric that was first used as a mop-up cloth.  After washing it, I decided it needed more, and so did a masking tape resist on it, using a deep wine for the covering color.  I was very pleased with the dramatic results
                </div>
            },
        ]
    },
    {
        id: 'freezer-paper',
        title: 'Freezer Paper',
        image: '/assets/images/fabrics/MaskWeddingCloth.jpg',
        variations: [
            {
                image: '/assets/images/fabrics/MaskWeddingCloth.jpg',
                description: <div>
                    Another way to mask the fabric before dyeing is with freezer paper, which is sold in the supermarket (I assume for use in the freezer). One side of this paper is coated with a thin layer of plastic, and so will adhere to cloth if it's ironed on. For the piece above, I cut out spirals (very much fun!!!), and ironed them on. I rolled over the resist with rust and purple thickened dye, then turned the fabric over and painted in the (still white) spirals with a couple colors of yellow.
                </div>
            },
            {
                image: '/assets/images/fabrics/MaskMossPaperDolls.jpg',
                description: <div>
                    Above is an example of paper dolls run amok! I started with a softly-colored mop-up, and ironed on the patterns you see in the light green. They were cut from freezer paper that I had first accordion-folded. I rolled over them with thickened brown and dark green dyes.
                </div>
            },
            {
                image: '/assets/images/fabrics/MaskJaggedRed.jpg',
                description: <div>
                    ...and here's one with the same sort of cutting technique for the freezer paper. The big difference in this one is that I used a patterned roller for all the dye application, adding a nice texture to the piece.
                </div>
            }
        ]
    },
    {
        id: 'potato-dextrin',
        title: 'Potato Dextrin',
        image: '/assets/images/fabrics/DexPlanets.jpg',
        details: <div>
            Potato dextrin is an amazing substance!  Basically starch, it comes as a powder, and is cooked up into a substance about the consistency of mayonaise.  One stretches the fabric, and then spreads the dextrin mixture on it.  As the dextrin dries, it shrinks a bit, making cracks in the surface of the resist.  The really wonderful thing is that the cracks are of differing fineness, depending on how thickly the dextrin was applied.
            <br /><br />
            I'd like to give you a link to a page full of wonderful pieces made with potato dextrin.  Debra Lunn and Michael Mrowka make marvelous fabrics for quiltmakers and others, and have done a lot of experimenting with potato dextrin.  (Their pictures are also much better at showing the cracking than mine are!)
        </div>,
        variations: [
            {
                image: '/assets/images/fabrics/DexCombWhite.jpg',
            },
            {
                image: '/assets/images/fabrics/DexCombOrange.jpg',
                description: <div>
                    Above are two closely-related pieces. First is the fabric as I first made it, showing the dextrin resist with an overlay of redish and greenish dye. Then, you see the cloth after I've vat-dyed the whole thing orange.
                </div>
            },
            {
                image: '/assets/images/fabrics/DextrinHand.jpg',
                description: <div>
                    Something that tickles me about potato dextrin is that it's non-toxic, and so can be applied directly with hands. (did you guess?)
                </div>
            },
            {
                image: '/assets/images/fabrics/DexGalaxy.jpg',
            },
            {
                image: '/assets/images/fabrics/DexPlanets.jpg',
                description: <div>
                    Above are two parts of the same cloth. For this one, I simply poured the dextrin on using a ladle. I left most of the big round blobs as is, but some (including the first) I manipulated to make a thinner, more jagged shape.
                </div>
            },
        ]
    },
    {
        id: 'discharge',
        title: 'Discharge',
        image: '/assets/images/fabrics/DisLines.jpg',
        details: <div>
            I've always been wary of using bleach to take away the color in already-dyed fabric; chlorine bleach is pretty caustic stuff, and I didn't want to muck myself or the environment up with it.  But at one point, a friend introduced me to a bleach gel that's manufactured as the soap for automatic dishwashers.  Its texture --about like mayonnaise-- is wonderful for stamping or silkscreening, and once I started using it, I found all sorts of wonderful effects that this color-stripper can have.
            <br /><br />
            I would only do this sort of work outside (i.e. in a well-ventilated environment), and wear a gas-mask as I work.  After I've applied the bleach-gel, I set the piece in the sun.  When the bleach has had as much effect as I want (this changes over time), I rinse the gel off in water, and then dunk the whole piece in a solution of something called Anti-Clor, which stops the bleaching reaction, and prevents deterioration of the fabric.
        </div>,
        variations: [
            {
                image: '/assets/images/fabrics/DisBlackWhiteShibori.jpg',
            },
            {
                image: '/assets/images/fabrics/DisBlackOrangeShibori.jpg',
                description: <div>
                    Both fabrics above were black before I got hold of them. Both were shibori-wrapped around a pole, and then bleach was applied (bleach gel on the first, liquid on the second). The dramatic difference in color has to do with what colors went into making the black with which the fabric was originally dyed. These are both commercial fabrics which looked pretty much the same, but the discharge shows that the components of the black in each one is different.
                </div>
            },
            {
                image: '/assets/images/fabrics/fDischargeLeaf.jpg',
                description: <div>
                    Above is a piece I discharged after I had dyed it. The subtle variations in the colors of the original cloth make this piece rich
                </div>
            },
            {
                image: '/assets/images/fabrics/fDischargeCDDet.jpg',
                description: <div>
                    Above is another piece which was multicolored before I discharged it, using a blank CD like a stamp to apply the gel. For each stamping, I brushed the gel onto the CD, each impression different from the last.
                </div>
            },
            {
                image: '/assets/images/fabrics/DisLines.jpg',
                description: <div>
                    Another above, with bleach gel squeezed from a small bottle.
                </div>
            },
            {
                image: '/assets/images/fabrics/DisPinkGoldComplex.jpg',
                description: <div>
                    And finally, a piece where the bleach gel was applied as a monotype. Note how the lighter lines are different colors in various parts of the cloth, depending on what colors were in the cloth before bleach was applied.
                </div>
            },
        ]
    },
    {
        id: 'stamping',
        title: 'Stamping',
        image: '/assets/images/fabrics/StampYellowWOmbre.jpg',
        details: <div>
            I never thought I would get interested in stamping images on fabric (seemed so tedious), but once I started playing with it, I kept thinking of new twists and variations, and the whole thing was very captivating!  The logical extention of stamping for me is rolling -- essentialy wrapping the stamping material around a cylinder and applying dye with it as you would in painting a wall.  The next page will show you some of that.
        </div>,
        variations: [
            {
                image: '/assets/images/fabrics/fQuietBlueStamp.jpg',
                description: <div>
                    The fabric above was one of my first stamped pieces.  The stamp was made of strips of pop-up sponge glued onto a plexiglas square.  By dipping the stamp in two different liquid dyes, the images came out with subtle variations in color.
                </div>
            },
            {
                image: '/assets/images/fabrics/fTablecloth.jpg',
                description: <div>
                    My pet name for the fabric abvoe is "tablecloth", because it's so fresh and perky -- reminds me of what might be on a diner table. The red squares were printed with a ravioli cutter.
                </div>
            },
            {
                image: '/assets/images/fabrics/StampYellowWOmbre.jpg',
                description: <div>
                    Above is a fabric which I stamped in yellow with a stamp I made of foam weatherstripping adhered to plexiglas. Then, after curing the fabric but not washing it, I did an ombre with greys and reds. The yellow (it tends to do this) "cuts through" the other colors.
                </div>
            },
            {
                image: '/assets/images/fabrics/fCircles.jpg',
                description: <div>
                    Above you see a piece where I have stamped the fabric, and then done ombre over it.  I love the way the red circles seem to recede or come forward, depending on what colors are around them.
                </div>
            }
        ]
    },
    {
        id: 'rubbing',
        title: 'Rubbing',
        image: '/assets/images/fabrics/RubFunkyMat.jpg',
        details: <div>
            Having realized that rolling was so much more efficient than stamping, I found a technique that gives even more bang for the buck! I gave it the name "rubbing" because it puts me in mind of grave rubbings.  A piece of textured something is placed on the table, and the cloth is laid over it.  Then I use a roller loaded with thickened dye to roll over the place in the cloth where the texture is.  All sorts of objects work well as the "textured something", and I'm always on the lookout for interesting bits of matting or grid.
        </div>,
        variations: [
            {
                image: '/assets/images/fabrics/fTextureRubber.jpg',
                description: <div>
                    For the texture on the above fabric, I used a small piece of some odd matting sort of material.  It had been acquired by a friend at one of those industrial scrap recycling places.  As I often do, I prepared two different thickened colors, and used them alternately on the roller.
                </div>
            },
            {
                image: '/assets/images/fabrics/RubFunkyMat.jpg',
                description: <div>
                    A close-up of the above fabric.
                </div>
            },
            {
                image: '/assets/images/fabrics/fOrangeGrid.jpg',
                description: <div>
                    The fabric above was patterned with a sample of plastic ceiling panelling -- the sort of thing one puts over fluorescent lighting fixtures.
                </div>
            },
            {
                image: '/assets/images/fabrics/RubRubberBands.jpg',
                description: <div>
                    Above you see an example of the use of a very ordinary object. I sprinkled rubber bands on my table, covered them with a piece of white fabric, and rolled over that with a roller. I had mixed up different thickened dyes, and moved from one color to another as I "inked" up my roller. After the first pass, the roller itself acquired a pattern; the rubber bands pressing into the foam made for a negative pattern of circles.
                </div>
            }
        ]
    },
    {
        id: 'leaves',
        title: 'Leaves!',
        image: '/assets/images/fabrics/fSumacFirst.jpg',
        details: <div>
            Inspired at first by the wonderful shapes of the artichoke leaves growing in the backyard in California, I started trying to make images of them on cloth.  My first attempts focused on coating a leaf with dye and printing that on the cloth to make a positive image.  This was (still is!) a pretty tedious business, and I've moved on to coloring a fabric using mostly negative images of leaves; I hold a leaf on the cloth in one hand and apply thickened dye with a roller held in the other.  I usually use many colors in one cloth, overlapping shapes and colors to create a very complex visual surface.
        </div>,
        variations: [
            {
                image: '/assets/images/babyquilts/bqLeavesFdet.jpg',
                description: <div>
                    Above is an early piece of leaf-patterned cloth. Using a roller filled with a dark purple-pinkish dye, I rolled over the interesting leaves of an unknown (by me, anyway) groundcover growing by the shores of Lake Champlain.  I then did a simple ombre over the patterned cloth.
                </div>
            },
            {
                image: '/assets/images/fabrics/fSumacFirst.jpg',
                description: <div>
                    To the right is the first of my sumac pieces.  Sumac is a weedy shrub which proliferates in Vermont.  In the fall, its leaves turn a beautiful orange-red.  It felt very luxurious to have as many leaves to use as I could possibly want, and the varying sizes made a nice variety in the resulting fabric.
                </div>
            },
            {
                image: '/assets/images/fabrics/SumacDetail3.jpg',
                description: <div>
                    Most of the imagery is a result of rolling over the sumac leaves (making a negative image), but in this picture you can see the print of a set of leaves as well.
                </div>
            },
            {
                image: '/assets/images/fabrics/fSumacOranges.jpg',
            },
            {
                image: '/assets/images/fabrics/fArtichoke.jpg',
                description: <div>
                    To the right is one of the pieces I've done in California. It uses the artichoke leaves which originally inspired all this leaf business in the first place!
                </div>
            }
        ]
    },
    {
        id: 'breakdown-screen-printing',
        title: 'Breakdown Screen Printing',
        image: '/assets/images/fabrics/squid.jpg',
        details: <div>
            I rarely take classes or workshops, but a few years ago while attending the SDA Conference I took a workshop with Claire Benn, from England. It was in something called breakdown silkscreen printing. Silkscreen has never appealed to me much; it seems too hard-edged. But this technique is a whole different kettle of fish!
            <br /><br />
            First, I paint (very) thickened dye on a silkscreen, and let that dry. (Note that this is a multi-day process.) Then I squeeze thickened dye through the prepared screen. Because the colors I put on the screen and the ones I'm pushing through are all water-based, the stuff on the screen dissolves as I go along, starting to deposit itself on the cloth along with what I'm putting through the screen. As a result, each pull of the screen produces a different image. This is all the more dramatic as I squeeze through multiple colors.
            <br /><br />
            An alternative to simply painting on the screen is to spread a layer of very thick dye over the whole screen, and then press objects into the goop. After the screen is dry, I remove the objects which have left patterns in the screen's design. The first few pulls of new dye will be mostly masked by what's on the screen, but eventually more and more color will come through. The fabric on the right was printed using a screen that had been prepared in this way, pressing a piece of large bubble wrap into the thick dye on the screen.
        </div>,
        variations: [
            {
                image: '/assets/images/fabrics/squid.jpg',
            },
            {
                image: '/assets/images/fabrics/oliveyellow.jpg',
            },
            {
                image: '/assets/images/fabrics/yellowgreenmaroon.jpg',
                description: <div>
                    The three pieces above are all done by painting or dripping the thickened dye on the screen, and then squeegeeing more color through.
                </div>
            },
            {
                image: '/assets/images/fabrics/bubblewrap-u17474.png',
            },
            {
                image: '/assets/images/fabrics/lightlavender-u17502.png',
                description: <div>
                    For the piece above, I prepared the screen with a couple different colors, simply dripping the thickened dye on and letting it dry. When I printed through the screen, I used no dye, but just the thickened clear goop (sodium alginate mixed with water) which is usually the medium in which the dyes are suspended. After printing through the screen, I scraped the cloth with a credit card, mixing and spreading the bits of color deposited by the screen.
                </div>
            },
            {
                image: '/assets/images/fabrics/discharge.jpg',
                description: <div>
                    And then there's the piece above, which got progressively uglier as I worked on it, until I had a deep brown mess that seemed irredeemable. But there's always hope...
                    <br /><br />
                    In this case, I prepared a screen with thickened goop (no dye), and when it was dry I squeezed through a thickened discharge agent (like bleach or thiox, but in this case I think we used Formosul). Discharging the ugly brown brought all sorts of wonderful colors shining through!
                    <br /><br />
                    The patterning is a result of dripping the thickener on in dots, and making lines into which I pressed round flattened glass "stones" purchased at a florist's shop
                </div>
            }
        ]
    },
    {
        id: 'indigo',
        title: 'Indigo',
        image: '/assets/images/fabrics/4stitchfinal.jpg',
        category: 'Fabrics',
        details: <div>
            My friend Ann bought an indigo kit from ProChem, which contained "pre-reduced" indigo. I don't really know what that means, but we followed the directions, and the results were spectacular!
        </div>,
        variations: [
            {
                image: '/assets/images/fabrics/thevat.jpg',
                description: <div>
                    Above is our prepared indigo vat. We mixed it up a few days before using it. It's about 3 gallons of stuff (water, indigo, thiox). One important thing about indigo is that it changes when it interacts with the air, so you want to introduce as little air as possible into the vat. This plastic bucket has a tight-fitting lid.
                </div>
            },
            {
                image: '/assets/images/fabrics/1chopstickbeforedyeing.jpg',
            },
            {
                image: '/assets/images/fabrics/1stitchbeforedyeing.jpg',
            },
            {
                image: '/assets/images/fabrics/1sausagebeforedyeing.jpg',
                description: <div>
                    We've prepared several pieces of cloth, both cotton and silk. Most effective are pieces that have been mechanically resisted -- meaning we fold and clamp, or fold and stitch (wrapped in Tyvek). We did some of each. Here are some of the pieces before dyeing.
                </div>
            },
            {
                image: '/assets/images/fabrics/1buttontied.jpg',
            },
            {
                image: '/assets/images/fabrics/2buttondetail.jpg',
                description: <div>
                    Ann also dyed a piece of cotton she'd previously dyed with our usual fiber-reactive dyes. She used small buttons, and wrapped rubber bands around each one.
                </div>
            },
            {
                image: '/assets/images/fabrics/handsinthevat.jpg',
                description: <div>
                    The bundles go in the vat. We attached a long string and clothespin to each package so we could keep track of them.
                    <br /><br />
                    As I understand it, indigo is not a dye, but a pigment, meaning it accumulates on the outside of the fiber (as opposed to dyes, which chemically bond with the fiber). So the dyeing method involves dipping each piece for a few minutes, and then exposing it to the air for 15 minutes.
                </div>
            },
            {
                image: '/assets/images/fabrics/2chopstickemergingfromvat.jpg'
            },
            {
                image: '/assets/images/fabrics/3buttonemerging.jpg'
            },
            {
                image: '/assets/images/fabrics/2sausageemerging.jpg'
            },
            {
                image: '/assets/images/fabrics/comparingcolorasitoxidizes.jpg',
                description: <div>
                    When we first take the bundles out of the vat, they don't look blue, but a fairly light green. The indigo only turns blue when exposed to the air. This is why there's the dipping and airing...
                    <br /><br />
                    Here are some pictures of the bundles the first time they emerge from the vat.
                    <br /><br />
                    They get progressively bluer as they are exposed to the air.
                </div>
            },
            {
                image: '/assets/images/fabrics/2stitchtakingapart.jpg',
                description: <div>
                    For a deeper hue, you repeat this cycle. We dipped our fabrics 3 and 4 times, and the result is amazingly intense. After the dipping and airing, we unwrapped the bundles. This is always exciting!
                    <br /><br />
                    Here's the stitch resist, which was wrapped in Tyvek in the pre-dye picture. Above, I'm taking the stitches out, and then I unfold the layers.
                </div>
            },
            {
                image: '/assets/images/fabrics/3stitchopeningup.jpg',
            },
            {
                image: '/assets/images/fabrics/4stitchfinal.jpg',
                description: <div>
                    You might detect the green in the photos above; the indigo hasn't fully oxidized in the parts of cloth that were inside the package. With time, it all turns blue of varying intensities.
                </div>
            },
            {
                image: '/assets/images/fabrics/3chopstickoutofthevat.jpg',
                description: <div>
                    Here's an even better illustration of the green effect. The picture above shows the bundle after I've removed the sticks, but before unwrapping. The outside of the package has been fully oxidized after its previous dippings.
                </div>
            },
            {
                image: '/assets/images/fabrics/4chopstickunfolding.jpg'
            },
            {
                image: '/assets/images/fabrics/5chopstickfinalwithface.jpg',
                description: <div>
                    As I unfold the cloth, we see all the places where the indigo has penetrated, but which haven't yet gotten exposed to the air. They'll all turn blue, but the green is a transitory treat!
                </div>
            },
        ]
    }
]